import React, { useEffect } from "react";
import Container from "@material-ui/core/Container";
import CreateIcon from "@material-ui/icons/Create";
import * as Glob from "src/Globale";
import { _MainContent, _PageTitle, _PageWrapper } from "../layout";
import { _PolicyNeutralAccordion, _PolicyCARAccordion } from "../components";

export const _NewPolicyCAR: React.FC<Glob.IRouteGlobaleProps> = props => {
/*    useEffect(() => {
        if (!Glob.AzioneAbilitata("FideAffidamentoController", Glob.Scrittura)) {
            location.replace("/ErroreAccesso");
            return;
        }
    }, []);*/

    return (
        <_PageWrapper {...props}>
            <Container component="main" maxWidth="lg">
                <_PageTitle Icon={CreateIcon} Title="Nuovo" />
                <_MainContent WithPaper={false}>
                    <_PolicyCARAccordion />
                </_MainContent>
            </Container>
        </_PageWrapper>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/pages/NewPolicyCAR.tsx